export const PAGE_ID_DESCRIPTION = -1;
export const PAGE_ID_LOADING = 'LOADING_PAGE';
export const PAGE_ID_SPEED_COURSE = 'SPEED_COURSE';
export const PAGE_ID_RESULTS = 'RESULTS_PAGE';
export const PAGE_ID_FINISHED = 'FINISHED_PAGE';
export const PAGE_ID_RUNTIME_ERROR = 'RUNTIME_ERROR_PAGE';
export const PAGE_ID_NO_PAGES = 'NO_PAGES_PAGE';
export const PAGE_ID_LOBBY = 'PAGE_ID_LOBBY';

export const PAGE_STATUS_INACTIVE = 'INACTIVE';
export const PAGE_STATUS_ENTERING = 'ENTERING';
export const PAGE_STATUS_ACTIVE = 'ACTIVE';
export const PAGE_STATUS_LEAVING = 'LEAVING';

export const SAVE_STATUS_UPLOADING = 'UPLOADING';
export const SAVE_STATUS_SAVED = 'SAVED';
export const SAVE_STATUS_FAILED = 'FAILED';
export const SAVE_STATUS_DIRTY = 'DIRTY';

export const PICTURESLIDES = 'PICTURESLIDES COMPONENT';
export const PICTURESQUESTIONNAIRE = 'PICTURESQUESTIONNAIRE COMPONENT';
export const QUESTIONNAIRE = 'QUESTIONNAIRE COMPONENT';
export const QUESTIONNAIREINPUT = 'QUESTIONNAIRE INPUT COMPONENT';

export const CONTENT = 'CONTENT COMPONENT';
export const TEXT = 'TEXT COMPONENT';
export const VIDEO = 'VIDEO COMPONENT';
export const DILEMMA = 'DILEMMA COMPONENT';
export const PICTURE = 'PICTURE COMPONENT';
export const EMBED = 'EMBED COMPONENT';

export const TEMPLATE_DILEMMA = 'TEXT-DILEMMA';
export const TEMPLATE_CONTENT = 'TEXT-CONTENT';
export const TEMPLATE_QUESTIONNAIRE = 'TEXT-QUESTIONNAIRE';
export const TEMPLATE_PICTURESLIDES = 'PICTURESLIDES-TEXT';
export const TEMPLATE_VIDEO = 'TEXT-VIDEO';
export const TEMPLATE_EMBED = 'TEMPLATE-EMBED';

export const TEMPLATE_PICTUREQUESTIONNAIRE = 'TEXT-PICTURESQUESTIONNAIRE';
export const TEMPLATE_INPUTQUESTIONNAIRE = 'INPUT-QUESTIONNAIRE';

export const EmptyArray = Object.freeze([]);
export const EmptyObject = Object.freeze({});

export const PageTypesEnum = {
  course: '1',
  infographics: '2',
};
